import { Component, ErrorInfo, ReactNode } from "react";

type RouteErrorBoundaryProps = {
  children: ReactNode;
};

type RouteErrorBoundaryState = {
  message: string;
};

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
  state: RouteErrorBoundaryState = {
    message: "",
  };

  static getDerivedStateFromError(_error: unknown): RouteErrorBoundaryState {
    return {
      message: "页面暂时无法正常显示，请重新加载后再试",
    };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("Teacher Web route error", error, info.componentStack);
  }

  render() {
    if (this.state.message) {
      return (
        <section className="card route-error-card">
          <p className="eyebrow">页面状态</p>
          <h3>页面运行异常</h3>
          <p>{this.state.message}</p>
          <button className="ghost-button" type="button" onClick={() => window.location.reload()}>
            重新加载
          </button>
        </section>
      );
    }

    return this.props.children;
  }
}
